'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _wonItems = require('./remote/wonItems');

exports.default = {
    fetchWonItems: _wonItems.WonItems.fetchWonItems
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/wonItems.js
// module id = zfNM
// module chunks = 60